import React from 'react';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import type {
  ClickCarouselLinkPayload,
  NavigateCarouselPayload,
  PillBarCarouselProps,
} from '@noths/polaris-client-ribbons-design-system';
import { PillBarCarousel } from '@noths/polaris-client-ribbons-design-system';

export enum LinkCarouselTrackingCategory {
  RelatedCategory = 'Related Category',
  ChildCategory = 'Child Category',
}

export enum LinkCarouselTrackingLinkSource {
  SimilarAI = 'similar.ai',
  Browse = 'browse',
}

export interface LinkCarouselProps extends PillBarCarouselProps {
  trackingCategory: LinkCarouselTrackingCategory;
  trackingLinkDataSource: LinkCarouselTrackingLinkSource;
}

export const LinkCarousel = ({
  title,
  links,
  trackingCategory,
  trackingLinkDataSource,
}: LinkCarouselProps) => {
  return (
    <PillBarCarousel
      title={title}
      links={links}
      onLinkClick={(
        evt: React.MouseEvent<HTMLAnchorElement>,
        { index }: ClickCarouselLinkPayload,
      ) => {
        sendGALinkClickEvent(evt, {
          event: 'custom_event',
          event_category: trackingCategory,
          event_action: 'Link Click',
          event_label: links[index].text,
          destination_URL: links[index].href.substring(0, 99),
          seo_link_source: trackingLinkDataSource,
        });
      }}
      onNavigateCarousel={({ navigation }: NavigateCarouselPayload) => {
        sendGAEvent({
          event: 'custom_event',
          event_category: trackingCategory,
          event_action: navigation.type,
          event_label: navigation.direction,
        });
      }}
      onVisible={() => {
        sendGAEvent({
          event: 'custom_event',
          event_category: trackingCategory,
          event_action: 'Impression',
          event_label: 'not set',
          seo_link_source: trackingLinkDataSource,
        });
      }}
    />
  );
};
